import s from './SocialMedia.module.scss';

const SocialMediaLogo = ({ logo, url, alt }) => (
  <div className={s.socialMediaLogo}>
    <a href={url} target='_blank'>
      <img src={logo} loading='lazy' width='35' height='35' border='0' alt={alt} />
    </a>
  </div>
);

export default SocialMediaLogo;
